import api from './client'

export interface LearningMaterialItem {
  id: number
  mastery_id: number | null
  mastery_name?: string | null
  title: string
  content: string | null
  media_type: string | null
  media_url: string | null
  is_active: boolean
  create_datetime: string | null
}

export interface PaginatedMaterials {
  items: LearningMaterialItem[]
  total: number
  page: number
  per_page: number
  total_pages: number
}

export interface MasteryOption {
  id: number
  name: string
  domain_name: string
}

export const learningMaterialsApi = {
  list: (params: { page?: number; per_page?: number; media_type?: string; mastery_id?: number }) =>
    api.get<PaginatedMaterials>('/admin/learning-materials', { params }),

  get: (id: number) => api.get<LearningMaterialItem>(`/admin/learning-materials/${id}`),

  create: (data: {
    title: string
    mastery_id?: number | null
    content?: string | null
    media_type?: string | null
    media_url?: string | null
  }) => api.post<{ message: string; id: number }>('/admin/learning-materials', data),

  update: (id: number, data: {
    title?: string
    mastery_id?: number | null
    content?: string | null
    media_type?: string | null
    media_url?: string | null
    is_active?: boolean
  }) => api.put<{ message: string }>(`/admin/learning-materials/${id}`, data),

  delete: (id: number) => api.delete<{ message: string }>(`/admin/learning-materials/${id}`),

  upload: (file: File) => {
    const fd = new FormData()
    fd.append('file', file)
    return api.post<{ url: string; filename: string }>('/admin/upload', fd)
  },

  getAllMasteries: () => api.get<MasteryOption[]>('/admin/all-masteries'),
}

/** Read-only catalog at `/api/learning-materials` (tutors + students). */
export const learningMaterialsCatalogApi = {
  list: (params?: { page?: number; per_page?: number; media_type?: string; mastery_id?: number }) =>
    api.get<PaginatedMaterials>('/learning-materials', { params }),

  get: (id: number) => api.get<LearningMaterialItem>(`/learning-materials/${id}`),
}
